export const ADVANCED_SEARCH_NAME = {
  query: "q",
  said_by: "sb",
};
